"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockSummary = getMockSummary;
const summaryStub_1 = __importDefault(require("./summaryStub"));
function getMockSummary(_conversationId) {
    return Promise.resolve({ summaryResponse: summaryStub_1.default });
}
